import { useLayoutEffect } from "react"
import { useRouter } from "next/navigation"

const useLatestBuild = () => {
  const router = useRouter()
  useLayoutEffect(() => {
    const versionBuildTime = process.env.NEXT_PUBLIC_BUILD_TIME
    const localBuildTime = localStorage.getItem("buildTime")
    if (!versionBuildTime) {
      return
    }
    if (!localBuildTime) {
      console.info(`first build: ${versionBuildTime}`)
      localStorage.setItem("buildTime", versionBuildTime)
      return
    }
    if (localBuildTime === versionBuildTime) {
      return
    }
    console.info(`new build - local: ${localBuildTime} new: ${versionBuildTime}`)
    localStorage.clear()
    localStorage.setItem("buildTime", versionBuildTime)
    setTimeout(() => {
      router.refresh()
    }, 0)
  }, [router])
}

export default useLatestBuild
